// Agent-generated placeholder names ("Unbekannter Typ 3") collide across plans without being the same type.
const PLACEHOLDER_GROUP_NAME = /^(unbekannter typ|unknown type)\b/i;

export const isPlaceholderGroupName = (name: string): boolean =>
  PLACEHOLDER_GROUP_NAME.test(name.trim());
